'use client';

import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { createContext, useContext } from 'react';
import { useImmerReducer } from 'use-immer';
import { jsx as _jsx } from "react/jsx-runtime";
var defaultInitialAppData = {
  screenSize: undefined,
  orientation: undefined,
  selectedLocation: undefined,
  selectedSubLocation: undefined,
  restaurantBrandName: undefined,
  occasionId: '',
  siteId: ''
};
var AppDataContext = createContext(null);
var AppDataDispatchContext = createContext(() => null);
export function AppDataProvider(_ref) {
  var children = _ref.children,
    initialAppData = _ref.initialAppData;
  var _useImmerReducer = useImmerReducer(appDataReducer, initialAppData !== null && initialAppData !== void 0 ? initialAppData : defaultInitialAppData),
    _useImmerReducer2 = _slicedToArray(_useImmerReducer, 2),
    appData = _useImmerReducer2[0],
    dispatch = _useImmerReducer2[1];
  return _jsx(AppDataContext.Provider, {
    value: appData,
    children: _jsx(AppDataDispatchContext.Provider, {
      value: dispatch,
      children: children
    })
  });
}
export function useAppData() {
  return useContext(AppDataContext);
}
export function useAppDataDispatch() {
  return useContext(AppDataDispatchContext);
}
function appDataReducer(appData, action) {
  switch (action.type) {
    case 'ui/screenSize':
      {
        appData.screenSize = action.payload;
        break;
      }
    case 'ui/orientation':
      {
        appData.orientation = action.payload;
        break;
      }
    case 'changeRestaurantName':
      {
        appData.restaurantBrandName = action.payload;
        break;
      }
    case 'changeRestaurantNameForMarketing':
      {
        appData.restaurantBrandNameForMarketing = action.payload;
        break;
      }
    case 'changeOccasionId':
      {
        appData.occasionId = action.payload;
        break;
      }
    case 'changeSiteId':
      {
        appData.siteId = action.payload;
        break;
      }
    default:
      {
        throw Error('Unknown action: ' + action.type);
      }
  }
}